<template>
    <svg :width="size" :height="size" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.10671 7.24732C8.04004 7.24065 7.96004 7.24065 7.88671 7.24732C6.30004 7.19398 5.04004 5.89398 5.04004 4.29398C5.04004 2.66065 6.36004 1.33398 8.00004 1.33398C9.63337 1.33398 10.96 2.66065 10.96 4.29398C10.9534 5.89398 9.69337 7.19398 8.10671 7.24732Z"
            stroke="#13293D" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" :class="strokeClass" />
        <path
            d="M4.77348 9.70602C3.16014 10.786 3.16014 12.546 4.77348 13.6193C6.60681 14.846 9.61348 14.846 11.4468 13.6193C13.0601 12.5393 13.0601 10.7793 11.4468 9.70602C9.62014 8.48602 6.61348 8.48602 4.77348 9.70602Z"
            stroke="#13293D" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" :class="strokeClass" />
    </svg>
</template>

<script setup lang="ts">
defineProps<{
    size: string,
    strokeClass?: string,
}>()
</script>